
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/live/app/schedule",
      function () {
        return require("private-next-pages/m/live/app/schedule.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/live/app/schedule"])
      });
    }
  